import axios from "axios";

const url = process.env.VUE_APP_API_BASE_URL;

axios.defaults.headers.post["Content-Type"] = "application/vnd.api+json";
axios.defaults.headers.common["Authorization"] =
  "Bearer " + localStorage.getItem("vue-authenticate.vueauth_access_token");
axios.defaults.headers.common["Accept"] = "application/vnd.api+json";

function saveConversation(payload) {
  return axios.post(`${url}/chat/conversation`, payload);
}

function saveMessage(payload, conversation_id) {
    return axios.post(`${url}/chat/conversations/${conversation_id}/messages`, payload);
}

function getConversations() {
    return axios.get(`${url}/chat/conversations`);
}

function getMessages(conversation_id) {
    return axios.get(`${url}/chat/conversations/${conversation_id}/messages`);
}

function markMessagesAsRead(conversation_id) {
  return axios.get(`${url}/chat/mark-as-read/${conversation_id}`);
}

function getUnreadMessages() {
  return axios.get(`${url}/chat/unread`);
}

export default {
    saveConversation,
    saveMessage,
    getConversations,
    getMessages,
    markMessagesAsRead,
    getUnreadMessages
};
  